var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pagination" }, [
    _vm.pager.total === 0
      ? _c("span", { staticClass: "count" }, [
          _vm._v(_vm._s(_vm.pager.total) + " 件"),
        ])
      : _c("div", [
          _c("span", { staticClass: "count" }, [
            _vm._v(
              _vm._s(_vm.pager.total) +
                " 件中 " +
                _vm._s(_vm.pager.offset + 1) +
                "〜" +
                _vm._s(_vm.pager.offset + _vm.pager.count) +
                "件を表示中"
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "prev",
              class: { active: _vm.pager.hasPrev() },
              on: {
                click: function ($event) {
                  return _vm.prev()
                },
              },
            },
            [_vm._v("<< 前の" + _vm._s(_vm.pager.limit) + "件へ")]
          ),
          _vm._v("\n    |\n    "),
          _c(
            "span",
            {
              staticClass: "next",
              class: { active: _vm.pager.hasNext() },
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [_vm._v("次の" + _vm._s(_vm.pager.limit) + "件へ >>")]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }